// extracted by mini-css-extract-plugin
export default {"close-icon":"kyX6U0dsTdBd9RLqOVHr","select":"x8iQLhGA4TxeaRbGypV7"};